import { createFileRoute, useNavigate } from '@tanstack/react-router';

import { SourceClientsPage } from '../../pages/sources';
import { useSession } from '../../entities/session';
import { listReturnState } from '../../shared/lib/list-return';

const text = (value: unknown): string | undefined =>
  typeof value === 'string' && value.length > 0 ? value : undefined;

export const Route = createFileRoute('/_shell/sources/$sourceId/clients/')({
  validateSearch: (search: Record<string, unknown>) => ({ q: text(search.q) }),
  component: function SourceClientsRoute() {
    const { sourceId } = Route.useParams();
    const { q } = Route.useSearch();
    const navigate = useNavigate();
    const session = useSession();

    return (
      <SourceClientsPage
        sourceId={sourceId}
        timeZone={session.data?.preferences.timezone}
        search={q ?? ''}
        onSearch={(next) =>
          void navigate({
            to: '/sources/$sourceId/clients',
            params: { sourceId },
            search: { q: next || undefined },
            replace: true,
          })
        }
        onOpenClient={(customerId) =>
          void navigate({
            to: '/sources/$sourceId/clients/$customerId',
            params: { sourceId, customerId },
            state: (prev) => ({ ...prev, ...listReturnState(q) }),
          })
        }
        onSetUpSigning={() =>
          void navigate({ to: '/sources/$sourceId', params: { sourceId }, hash: 'signing' })
        }
      />
    );
  },
});
